module.exports = __webpack_public_path__ + "img/icon-handshake-green@3x.97700adf.png";